/**
 * @name BranchService
 * @description Servicio para gestionar las sucursales en Administración
 * @author Ricardo Guerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Consulta las sucursales de una empresa
 * Cualquier usuario con acceso a Talentry puede consultar este servicio
 * @param {any} request filter { sucursal, codigo, estatus, columns }
 * @return {any} promise
 */
const get = (request) => {
  let branch = request.filter.sucursal === undefined ? '' : `&sucursal=${request.filter.sucursal}`;
  let code = request.filter.codigo === undefined ? '' : `&codigo=${request.filter.codigo}`;
  let status = request.filter.estatus === undefined ? '' : `&estatus=${request.filter.estatus}`;
  let columns = request.filter.columnas === undefined ? '' : `&columnas=${request.filter.columnas}`;

  let URL = `${BASE_URL}/Sucursal?paginado=0,0${branch}${code}${status}${columns}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta una sucursal de una empresa
 * @param {any} request IdSucursal
 * @return {any} promise
 */
const getById = (request) => {
  let URL = `${BASE_URL}/Sucursal/${request}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Añade una sucursal
 * @param {object} sucursal
 * @return {any} promise
 */
const post = (sucursal) => {
  let URL = `${BASE_URL}/Sucursal`;

  return axios.post(URL, sucursal).then(({ data }) => {
    return data;
  });
};

/**
 * Actualiza una sucursal
 * @param {object} sucursal
 * @return {any} promise
 */
const put = (sucursal) => {
  let URL = `${BASE_URL}/Area/${sucursal.IdSucursal}`;

  return axios.put(URL, sucursal).then(({ data }) => {
    return data;
  });
};

export const BranchService = {
  get,
  getById,
  post,
  put
};